// Copyright (c) Move Closer 2022.

import { ConnectorMiddleware, FoundResource, Headers, Injectable, IResponse, Payload } from '@movecloser/front-core'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface ISupportFormats extends ConnectorMiddleware {
  hasSupportedFormats (): boolean
  setSupportedFormats (formats: string): void
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
@Injectable()
export class SupportedFormatsMiddleware implements ISupportFormats {
  protected supportedFormats: string | null = null

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public afterCall (response: IResponse, resource: FoundResource): void {
    // Do nothing
  }

  public beforeCall (
    resource: FoundResource,
    headers: Headers,
    body: Payload
  ): { headers: Headers; body: Payload } | Promise<{ headers: Headers; body: Payload }> {
    headers['X-Browser-Accept'] = this.supportedFormats ?? ''

    return { headers, body }
  }

  public hasSupportedFormats (): boolean {
    return this.supportedFormats !== null
  }

  public setSupportedFormats (formats: string): void {
    this.supportedFormats = formats
  }
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const SupportedFormatsMiddlewareType = Symbol.for('ISupportFormats')
